import React from 'react'
import TotalsStats from './totalsStats';
import { useData } from '../../dataProvider';

function Totals() {
  const { trends: {trend_kills, trend_time}} = useData();

  return (
    <div style={{display: 'flex', justifyContent: 'space-between'}}>
      <TotalsStats total={trend_kills} title="Тотал убийств"/>
      <TotalsStats total={trend_time} title="Тотал времени"/>
    </div>
  )
}

export default Totals
